// ─── Shared styles — earthy orange palette (matches series) ──────────────────
const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid #7a2e00', fontFamily:"'Georgia',serif", color:'#1a0e06', lineHeight:'1.7', background:'#fdf6ee' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c45a10', paddingBottom:'8px', marginBottom:'24px', color:'#7a2e00' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#a04010', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c45a10', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'1rem' },
  infoBox:      { background:'#fdf0e4', border:'2px solid #c45a10', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New',monospace", fontSize:'0.92rem', color:'#7a2e00', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.95rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c45a10' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.95rem' },
  th:           { background:'#a04010', color:'#fff', padding:'11px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.93rem' },
  tdE:          { padding:'11px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf4ec' },
  tdO:          { padding:'11px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf6ee' },
  tdL:          { fontWeight:'600', color:'#7a2e00', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New',monospace", fontSize:'0.92rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fdf4ec', border:'1px solid #e8b07a', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'1rem', color:'#7a2e00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.88rem', color:'#7a4a28', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((it,i)=><div key={i} style={S.infoBoxItem}>{it}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{...S.th,width:'220px'}}>Concept</th>
        <th style={S.th}>Detail</th>
      </tr></thead>
      <tbody>{rows.map(([l,v],i)=>(
        <tr key={i}>
          <td style={{...(i%2===0?S.tdE:S.tdO),...S.tdL}}>{l}</td>
          <td style={{...(i%2===0?S.tdE:S.tdO),...S.code}}>{v}</td>
        </tr>
      ))}</tbody>
    </table>
  );
}

// ─── SVG arrow helpers ────────────────────────────────────────────────────────
function arrowDef(id, color='#c45a10') {
  return (
    <marker id={id} markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
      <polygon points="0 0,7 4,0 8" fill={color}/>
    </marker>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 1 — Flywheel anatomy: cross-section with labelled parts
// ─────────────────────────────────────────────────────────────────────────────
function DiagramAnatomy() {
  const W=980, H=420;
  const cx=260, cy=210; // flywheel centre

  // Radii
  const Ro=160, Ri=40, hubR=28, shaftR=14;
  const rimW=28; // rim thickness
  const webR=Ro-rimW; // inner edge of rim = outer edge of web/spokes

  // Draw concentric flywheel cross-section
  // Full disc (solid disc type) shown left, spoked type shown right
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Flywheel Anatomy — Cross-Section: Rim · Web/Disc · Hub · Shaft · Key Dimensions</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          {arrowDef('arAN')}
          {arrowDef('arANr','#7a2e00')}
        </defs>

        {/* ── Left: Solid disc flywheel ── */}
        {(()=>{
          const lx=220, ly=210;
          return <g>
            <text x={lx} y={34} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Solid Disc Flywheel</text>
            {/* Shaft FIRST so flywheel renders on top */}
            <rect x={lx-shaftR} y={46} width={shaftR*2} height={ly-hubR-46} rx={shaftR}
              fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>
            <rect x={lx-shaftR} y={ly+hubR+4} width={shaftR*2} height={ly-hubR-46} rx={shaftR}
              fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>
            {/* Outer rim ring */}
            <circle cx={lx} cy={ly} r={Ro} fill="#d4874a" stroke="#7a2e00" strokeWidth="3"/>
            {/* Web / disc body */}
            <circle cx={lx} cy={ly} r={Ro-rimW} fill="#e8b07a" stroke="#7a2e00" strokeWidth="1.5"/>
            {/* Hub */}
            <circle cx={lx} cy={ly} r={hubR} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
            {/* Shaft bore */}
            <circle cx={lx} cy={ly} r={shaftR} fill="#fdf0e4" stroke="#5a1e00" strokeWidth="2"/>
            {/* Keyway slot */}
            <rect x={lx-shaftR+2} y={ly-shaftR-8} width={shaftR*2-4} height={10} rx={1}
              fill="#fdf0e4" stroke="#5a1e00" strokeWidth="1.5"/>
            {/* Dimension lines */}
            <line x1={lx} y1={ly} x2={lx+Ro} y2={ly}
              stroke="#7a2e00" strokeWidth="1.2" strokeDasharray="4,3"/>
            <line x1={lx+Ro+8} y1={ly-24} x2={lx+Ro+8} y2={ly+24}
              stroke="#7a2e00" strokeWidth="1.2"
              markerStart="url(#arANr)" markerEnd="url(#arANr)"/>
            <text x={lx+Ro+22} y={ly+4} fontSize="9.5" fontWeight="700" fill="#7a2e00">R</text>
            <line x1={lx+Ro-rimW-4} y1={ly+Ro+12} x2={lx+Ro+4} y2={ly+Ro+12}
              stroke="#c45a10" strokeWidth="1.2"
              markerStart="url(#arAN)" markerEnd="url(#arAN)"/>
            <text x={lx+Ro-rimW/2-2} y={ly+Ro+26} textAnchor="middle" fontSize="9" fill="#c45a10">t_rim</text>
          </g>;
        })()}

        {/* ── Callout labels — RIGHT of left diagram ── */}
        {[
          { r: Ro,      label:'Rim',        sub:'High-density mass at max radius', lx:440, ly:115 },
          { r: Ro-rimW, label:'Web / Disc',  sub:'Transfers torque; solid or spoked',lx:440, ly:175 },
          { r: hubR,    label:'Hub',         sub:'Press-fit or keyed to shaft',      lx:440, ly:240 },
          { r: shaftR,  label:'Shaft bore',  sub:'Through-bore or blind',            lx:440, ly:300 },
        ].map(({r, label, sub, lx:tlx, ly:tly},i)=>{
          const angle = [-0.3, -0.1, 0.15, 0.4][i];
          const px = 220 + r*Math.cos(angle), py = 210 + r*Math.sin(angle);
          return (
            <g key={i}>
              <line x1={px} y1={py} x2={tlx-8} y2={tly}
                stroke="#c45a10" strokeWidth="1.2"/>
              <circle cx={px} cy={py} r={3.5} fill="#c45a10"/>
              <rect x={tlx} y={tly-14} width={240} height={30} rx={3}
                fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.2"/>
              <text x={tlx+8} y={tly+1}  fontSize="10" fontWeight="700" fill="#7a2e00">{label}</text>
              <text x={tlx+8} y={tly+14} fontSize="9"   fill="#a04010">{sub}</text>
            </g>
          );
        })}

        {/* ── Right: Spoked flywheel ── */}
        {(()=>{
          const rx=750, ry=210;
          const spokeN=6;
          return <g>
            <text x={rx} y={34} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Spoked Flywheel</text>
            {/* Shaft FIRST so wheel renders on top */}
            <rect x={rx-shaftR} y={46}          width={shaftR*2} height={ry-hubR-12-46} rx={shaftR}
              fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>
            <rect x={rx-shaftR} y={ry+hubR+14}  width={shaftR*2} height={ry-hubR-46}   rx={shaftR}
              fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>
            {/* Outer rim */}
            <circle cx={rx} cy={ry} r={Ro}      fill="none" stroke="#7a2e00" strokeWidth="26"/>
            <circle cx={rx} cy={ry} r={Ro}      fill="none" stroke="#d4874a" strokeWidth="22"/>
            {/* Spokes */}
            {Array.from({length:spokeN},(_,i)=>{
              const a = i*(2*Math.PI/spokeN) + Math.PI/6;
              return <line key={i}
                x1={rx + hubR*Math.cos(a)}   y1={ry + hubR*Math.sin(a)}
                x2={rx + (Ro-rimW/2)*Math.cos(a)} y2={ry + (Ro-rimW/2)*Math.sin(a)}
                stroke="#c45a10" strokeWidth="18" strokeLinecap="round"/>;
            })}
            {/* Hub */}
            <circle cx={rx} cy={ry} r={hubR+12} fill="#d4874a" stroke="#7a2e00" strokeWidth="2"/>
            <circle cx={rx} cy={ry} r={hubR}    fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
            <circle cx={rx} cy={ry} r={shaftR}  fill="#fdf0e4" stroke="#5a1e00" strokeWidth="2"/>
            {/* Spoke label */}
            <line x1={rx+Ro*0.55} y1={ry-Ro*0.3} x2={rx+Ro*0.55+40} y2={ry-Ro*0.3-30}
              stroke="#c45a10" strokeWidth="1.2"/>
            <rect x={rx+Ro*0.55+44} y={ry-Ro*0.3-44} width={70} height={16} rx={3}
              fill="#fdf0e4" stroke="#c45a10" strokeWidth="1"/>
            <text x={rx+Ro*0.55+50} y={ry-Ro*0.3-31} fontSize="9.5" fontWeight="700" fill="#7a2e00">Spoke</text>
          </g>;
        })()}

        {/* Bottom note */}
        <rect x={10} y={H-30} width={W-20} height={22} rx={4} fill="#fdf0e4" stroke="#e8b07a" strokeWidth="1"/>
        <text x={W/2} y={H-15} textAnchor="middle" fontSize="10" fill="#7a2e00">
          Solid disc: lower I but more uniform stress  ·  Spoked: concentrates mass at rim for higher I-to-weight ratio
        </text>
      </svg>
      <div style={S.dCaption}>The rim carries the majority of stored energy — placing mass at maximum radius maximises moment of inertia for a given total mass, since I = mr²</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 2 — Moment of inertia: geometry comparison for 5 cross-sections
// ─────────────────────────────────────────────────────────────────────────────
function DiagramMomentOfInertia() {
  const W=980, H=390;

  const shapes = [
    { name:'Solid Cylinder',  formula:'I = ½mR²',        k:'k=R/√2',   ratio:0.50, color:'#c45a10',
      draw:(cx,cy,r)=><circle cx={cx} cy={cy} r={r} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/> },
    { name:'Thin Ring',       formula:'I = mR²',          k:'k=R',      ratio:1.00, color:'#7a2e00',
      draw:(cx,cy,r)=><><circle cx={cx} cy={cy} r={r} fill="none" stroke="#7a2e00" strokeWidth="20"/><circle cx={cx} cy={cy} r={r} fill="none" stroke="#d4874a" strokeWidth="16"/></> },
    { name:'Hollow Cylinder', formula:'I = ½m(R²+Ri²)',   k:'k>R/√2',   ratio:0.75, color:'#d4874a',
      draw:(cx,cy,r)=><><circle cx={cx} cy={cy} r={r} fill="#d4874a" stroke="#7a2e00" strokeWidth="2"/><circle cx={cx} cy={cy} r={r*0.55} fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.5"/></> },
    { name:'Spoked Rim',      formula:'I ≈ 0.9mR²',       k:'k≈0.95R',  ratio:0.90, color:'#a04010',
      draw:(cx,cy,r)=><>{Array.from({length:6},(_,i)=>{const a=i*Math.PI/3;return <line key={i} x1={cx+12*Math.cos(a)} y1={cy+12*Math.sin(a)} x2={cx+r*0.85*Math.cos(a)} y2={cy+r*0.85*Math.sin(a)} stroke="#c45a10" strokeWidth="7" strokeLinecap="round"/>})}<circle cx={cx} cy={cy} r={r} fill="none" stroke="#a04010" strokeWidth="18"/><circle cx={cx} cy={cy} r={r} fill="none" stroke="#d4874a" strokeWidth="14"/><circle cx={cx} cy={cy} r={14} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/></> },
    { name:'Flat Disc (thin)',  formula:'I = ½mR²',        k:'k=R/√2',   ratio:0.50, color:'#c4a010',
      draw:(cx,cy,r)=><ellipse cx={cx} cy={cy} rx={r} ry={r*0.18} fill="#c4a010" stroke="#7a2e00" strokeWidth="2"/> },
  ];

  const colW = W/shapes.length;
  const shapeR = 62;
  const shapeCY = 130;  // shape centres

  // Formula boxes sit below shapes: y range = shapeCY+shapeR+18 to shapeCY+shapeR+60
  // Bars start at barBaseY - ratio*maxBarH; barBaseY=350 with maxBarH=80 gives bar tops at 270–350
  // Formula bottom = 130+62+60 = 252 → bars start at 270 → 18px gap ✓
  const barBaseY = 350, maxBarH = 80, barW = 44;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Moment of Inertia by Geometry — I = k·m·R²  ·  Comparison of Five Cross-Sections</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>{arrowDef('arMI')}</defs>

        {shapes.map((sh, i) => {
          const cx = colW*i + colW/2;
          return (
            <g key={i}>
              {sh.draw(cx, shapeCY, shapeR)}
              {/* Name */}
              <text x={cx} y={shapeCY+shapeR+18} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">{sh.name}</text>
              {/* Formula box — sits below name */}
              <rect x={cx-66} y={shapeCY+shapeR+24} width={132} height={30} rx={3}
                fill="#fdf0e4" stroke="#e8b07a" strokeWidth="1"/>
              <text x={cx} y={shapeCY+shapeR+38} textAnchor="middle" fontSize="10" fontFamily="'Courier New',monospace" fontWeight="700" fill={sh.color}>{sh.formula}</text>
              <text x={cx} y={shapeCY+shapeR+51} textAnchor="middle" fontSize="9" fontFamily="'Courier New',monospace" fill="#a04010">{sh.k}</text>
              {/* Bar — starts at barBaseY - ratio*maxBarH, well below formula box */}
              <rect x={cx-barW/2} y={barBaseY-sh.ratio*maxBarH} width={barW} height={sh.ratio*maxBarH}
                fill={sh.color} stroke="#7a2e00" strokeWidth="1.2" opacity="0.85" rx={2}/>
              <text x={cx} y={barBaseY-sh.ratio*maxBarH-6} textAnchor="middle"
                fontSize="10" fontWeight="700" fill={sh.color}>{(sh.ratio*100).toFixed(0)}%</text>
            </g>
          );
        })}

        {/* Bar chart baseline */}
        <line x1={20} y1={barBaseY} x2={W-20} y2={barBaseY} stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={W/2} y={barBaseY+18} textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#7a2e00">
          Relative I (% of thin ring = mR²)
        </text>
      </svg>
      <div style={S.dCaption}>The thin ring achieves the highest I for a given mass because all mass sits at radius R — every solid disc or disc with a hole is a compromise between maximum I and structural integrity</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 3 — Energy storage and torque smoothing: input/output torque curves
// ─────────────────────────────────────────────────────────────────────────────
function DiagramEnergySmoothing() {
  const W=980, H=340;
  const chartX=50, chartY=30, chartW=430, chartH=240;
  const baseY = chartY + chartH;

  // One cycle of engine torque (4-stroke single-cylinder: one power stroke per 2 rev)
  const N=200;
  const pts = Array.from({length:N}, (_,i)=>{
    const t = i/(N-1);
    const angle = t * 2 * Math.PI;
    // Single-cylinder 4-stroke: one large positive pulse per revolution
    const torque = 0.5 + 0.45*Math.sin(angle) + 0.35*Math.max(0, Math.sin(angle*2+0.4))
                 - 0.15*Math.sin(angle*3);
    return { t, angle, torque };
  });

  const maxT=1.2, minT=-0.1;
  function toX(t) { return chartX + t*chartW; }
  function toY(v) { return baseY - ((v-minT)/(maxT-minT))*chartH; }

  // Mean torque (load line)
  const mean = pts.reduce((s,p)=>s+p.torque,0)/pts.length;
  const meanY = toY(mean);

  // Instantaneous torque path
  const enginePath = 'M ' + pts.map(p=>`${toX(p.t).toFixed(1)},${toY(p.torque).toFixed(1)}`).join(' L ');

  // Smooth output (flywheel — nearly constant)
  const flywheelPts = pts.map(p=>({ t:p.t, torque: mean + 0.04*Math.sin(p.angle*2) }));
  const flywheelPath = 'M ' + flywheelPts.map(p=>`${toX(p.t).toFixed(1)},${toY(p.torque).toFixed(1)}`).join(' L ');

  // Shaded energy storage region (above mean) and release region (below mean)
  const storagePts = pts.filter(p=>p.torque>mean);
  const firstStore = storagePts[0]?.t ?? 0;
  const lastStore  = storagePts[storagePts.length-1]?.t ?? 1;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Torque Smoothing — Engine Power Pulse vs. Load Line · Energy Stored &amp; Released Each Cycle</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>{arrowDef('arES')}</defs>

        {/* Chart background */}
        <rect x={chartX} y={chartY} width={chartW} height={chartH}
          fill="#fdf0e4" stroke="#e8b07a" strokeWidth="1.5" rx={4}/>

        {/* Grid lines — horizontal */}
        {[0,0.2,0.4,0.6,0.8,1.0].map(v=>{
          const y=toY(v);
          return <g key={v}>
            <line x1={chartX} y1={y} x2={chartX+chartW} y2={y}
              stroke="#e8b07a" strokeWidth="0.8" strokeDasharray="4,3"/>
            <text x={chartX-8} y={y+4} textAnchor="end" fontSize="9" fill="#7a4a28">{v.toFixed(1)}</text>
          </g>;
        })}
        {/* X axis ticks */}
        {[0,0.25,0.5,0.75,1.0].map(t=>(
          <text key={t} x={toX(t)} y={baseY+16} textAnchor="middle" fontSize="9" fill="#7a4a28">
            {(t*360).toFixed(0)}°
          </text>
        ))}

        {/* Axis labels */}
        <text x={chartX+chartW/2} y={baseY+30} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Crankshaft Angle</text>
        <text x={chartX-36} y={chartY+chartH/2} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00"
          transform={`rotate(-90,${chartX-36},${chartY+chartH/2})`}>Torque (normalised)</text>

        {/* Energy storage shading (above mean) */}
        {(()=>{
          const abovePts = pts.filter(p=>p.torque>=mean);
          if(abovePts.length<2) return null;
          const pPath = abovePts.map(p=>`${toX(p.t).toFixed(1)},${toY(p.torque).toFixed(1)}`).join(' ');
          const startX=toX(abovePts[0].t), endX=toX(abovePts[abovePts.length-1].t);
          return <path
            d={`M ${startX},${meanY} L ${pPath} L ${endX},${meanY} Z`}
            fill="#c45a10" opacity="0.15"/>;
        })()}
        {/* Energy release shading (below mean) */}
        {(()=>{
          const belowPts = pts.filter(p=>p.torque<mean);
          if(belowPts.length<2) return null;
          const pPath = belowPts.map(p=>`${toX(p.t).toFixed(1)},${toY(p.torque).toFixed(1)}`).join(' ');
          const startX=toX(belowPts[0].t), endX=toX(belowPts[belowPts.length-1].t);
          return <path
            d={`M ${startX},${meanY} L ${pPath} L ${endX},${meanY} Z`}
            fill="#5a7820" opacity="0.15"/>;
        })()}

        {/* Mean torque / load line */}
        <line x1={chartX} y1={meanY} x2={chartX+chartW} y2={meanY}
          stroke="#7a2e00" strokeWidth="2" strokeDasharray="8,4"/>
        <text x={chartX+chartW-4} y={meanY-6} textAnchor="end" fontSize="9.5" fontWeight="700" fill="#7a2e00">Mean torque (load)</text>

        {/* Engine torque curve */}
        <path d={enginePath} fill="none" stroke="#c45a10" strokeWidth="2.5" opacity="0.9"/>

        {/* Flywheel output (smoothed) */}
        <path d={flywheelPath} fill="none" stroke="#5a7820" strokeWidth="2.5" strokeDasharray="6,3"/>

        {/* Legend */}
        <line x1={chartX+10} y1={chartY+16} x2={chartX+40} y2={chartY+16} stroke="#c45a10" strokeWidth="2.5"/>
        <text x={chartX+46} y={chartY+20} fontSize="10" fontWeight="700" fill="#c45a10">Engine torque</text>
        <line x1={chartX+10} y1={chartY+32} x2={chartX+40} y2={chartY+32} stroke="#5a7820" strokeWidth="2.5" strokeDasharray="6,3"/>
        <text x={chartX+46} y={chartY+36} fontSize="10" fontWeight="700" fill="#5a7820">Flywheel output</text>

        {/* Storage / release annotations */}
        <text x={toX(0.28)} y={toY(mean+0.22)} textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#c45a10">Storing energy ↑</text>
        <text x={toX(0.68)} y={toY(mean-0.22)} textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#5a7820">Releasing energy ↓</text>

        {/* Right panel — key equations */}
        <rect x={520} y={30} width={448} height={270} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={744} y={52} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Key Equations</text>
        <line x1={528} y1={60} x2={960} y2={60} stroke="#e8b07a"/>
        {[
          ['Kinetic energy:',     'E = ½Iω²   (J)'],
          ['',                    'I = moment of inertia (kg·m²)'],
          ['',                    'ω = angular velocity (rad/s)'],
          ['Energy change:',      'ΔE = ½I(ω_max² − ω_min²)'],
          ['',                    ''],
          ['Coefficient of',      'Cs = (ω_max − ω_min) / ω_mean'],
          ['  fluctuation:',      'Typical: 0.002 (turbines) to 0.2 (punch)'],
          ['',                    ''],
          ['Required I:',         'I = ΔE / (Cs × ω_mean²)'],
          ['',                    'Design equation — solve for I given'],
          ['',                    'allowable speed fluctuation Cs'],
          ['',                    ''],
          ['Angular impulse:',    'ΔE = T_net · Δθ   (excess torque × angle)'],
          ['',                    'Area between curve and load line'],
          ['',                    ''],
          ['Speed ripple:',       'Δω = ΔE / (I × ω_mean)'],
          ['',                    'Smaller I → larger speed ripple'],
        ].map(([l,v],i)=>(
          <g key={i}>
            <text x={530} y={74+i*14} fontSize="10" fontWeight={l?'700':'400'} fill="#7a2e00">{l}</text>
            <text x={l?668:536} y={74+i*14} fontSize="10" fontFamily="'Courier New',monospace" fill="#a04010">{v}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The flywheel absorbs kinetic energy when engine torque exceeds the load (shaded orange) and releases it when engine torque falls below the load (shaded green) — maintaining nearly constant speed</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 4 — Stress analysis: hoop stress, radial stress, burst speed
// ─────────────────────────────────────────────────────────────────────────────
function DiagramStress() {
  const W=980, H=360;

  // Lame equations for rotating disc: hoop and radial stress vs radius
  const Ro=1.0, Ri=0.2; // normalised radii
  const ν=0.3, ρ=1.0, ω=1.0;
  const N=100;
  const radii = Array.from({length:N},(_,i)=> Ri + i*(Ro-Ri)/(N-1));

  // Rotating disc stress (Lame equations):
  // σ_hoop = ρω²/8 × [(3+ν)(Ro²+Ri²) − (1+3ν)r²  + (3+ν)Ro²Ri²/r²]
  // σ_radial= ρω²/8 × [(3+ν)(Ro²+Ri²) − (3+ν)r²   − (3+ν)Ro²Ri²/r²]  (simplified, free surfaces)
  function stresses(r) {
    const C = (3+ν)/8;
    const hoop   = C*(Ro*Ro + Ri*Ri + Ro*Ro*Ri*Ri/(r*r) - (1+3*ν)/(3+ν)*r*r);
    const radial = C*(Ro*Ro + Ri*Ri - Ro*Ro*Ri*Ri/(r*r) - r*r);
    return { hoop: Math.max(0,hoop), radial: Math.max(0,radial) };
  }

  const stressData = radii.map(r=>({r, ...stresses(r)}));
  const maxS = Math.max(...stressData.map(d=>d.hoop));

  // Chart
  const chartX=50, chartY=30, chartW=450, chartH=260;
  const baseY=chartY+chartH;

  function toX(r) { return chartX + (r-Ri)/(Ro-Ri)*chartW; }
  function toY(s) { return baseY - (s/maxS)*chartH; }

  const hoopPath   = 'M '+stressData.map(d=>`${toX(d.r).toFixed(1)},${toY(d.hoop).toFixed(1)}`).join(' L ');
  const radialPath = 'M '+stressData.map(d=>`${toX(d.r).toFixed(1)},${toY(d.radial).toFixed(1)}`).join(' L ');

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Stress Analysis — Hoop &amp; Radial Stress vs. Radius · Burst Speed · Safety Factor</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>{arrowDef('arST')}</defs>

        {/* Chart background */}
        <rect x={chartX} y={chartY} width={chartW} height={chartH}
          fill="#fdf0e4" stroke="#e8b07a" strokeWidth="1.5" rx={4}/>

        {/* Grid */}
        {[0,0.25,0.5,0.75,1.0].map(v=>{
          const y=toY(v*maxS);
          return <g key={v}>
            <line x1={chartX} y1={y} x2={chartX+chartW} y2={y}
              stroke="#e8b07a" strokeWidth="0.8" strokeDasharray="4,3"/>
            <text x={chartX-8} y={y+4} textAnchor="end" fontSize="9" fill="#7a4a28">{(v).toFixed(2)}</text>
          </g>;
        })}
        {[0,0.25,0.5,0.75,1.0].map(v=>{
          const r=Ri+(Ro-Ri)*v;
          return <text key={v} x={toX(r)} y={baseY+16} textAnchor="middle" fontSize="9" fill="#7a4a28">
            {v===0?'Ri':v===1?'Ro':(v).toFixed(2)+'R'}
          </text>;
        })}

        {/* Axes */}
        <text x={chartX+chartW/2} y={baseY+30} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Radius (r/Ro)</text>
        <text x={chartX-42} y={chartY+chartH/2} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00"
          transform={`rotate(-90,${chartX-42},${chartY+chartH/2})`}>Stress (normalised)</text>

        {/* Hoop stress curve */}
        <path d={hoopPath} fill="none" stroke="#c45a10" strokeWidth="2.8"/>
        {/* Radial stress curve */}
        <path d={radialPath} fill="none" stroke="#5a7820" strokeWidth="2.8" strokeDasharray="7,4"/>

        {/* Max hoop annotation at bore */}
        <circle cx={toX(Ri)} cy={toY(stressData[0].hoop)} r={5} fill="#c45a10" stroke="#7a2e00" strokeWidth="1.5"/>
        <line x1={toX(Ri)+8} y1={toY(stressData[0].hoop)-4} x2={toX(Ri)+60} y2={toY(stressData[0].hoop)-36}
          stroke="#c45a10" strokeWidth="1.2"/>
        <text x={toX(Ri)+64} y={toY(stressData[0].hoop)-30} fontSize="9.5" fontWeight="700" fill="#c45a10">σ_hoop max</text>
        <text x={toX(Ri)+64} y={toY(stressData[0].hoop)-17} fontSize="9"   fill="#c45a10">at bore radius</text>

        {/* Legend */}
        <line x1={chartX+12} y1={chartY+14} x2={chartX+42} y2={chartY+14} stroke="#c45a10" strokeWidth="2.8"/>
        <text x={chartX+48} y={chartY+18} fontSize="10" fontWeight="700" fill="#c45a10">Hoop stress σ_θ</text>
        <line x1={chartX+12} y1={chartY+30} x2={chartX+42} y2={chartY+30} stroke="#5a7820" strokeWidth="2.8" strokeDasharray="7,4"/>
        <text x={chartX+48} y={chartY+34} fontSize="10" fontWeight="700" fill="#5a7820">Radial stress σ_r</text>

        {/* Right panel */}
        <rect x={530} y={24} width={438} height={318} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={749} y={46} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Stress &amp; Burst Analysis</text>
        <line x1={538} y1={54} x2={960} y2={54} stroke="#e8b07a"/>
        {[
          ['Hoop stress (Lame):', 'σ_θ = ρω²/8 · [(3+ν)(Ro²+Ri²)'],
          ['',                    '      + Ro²Ri²/r² − (1+3ν)r²]'],
          ['',                    ''],
          ['Radial stress:',      'σ_r = ρω²/8 · [(3+ν)(Ro²+Ri²)'],
          ['',                    '      − Ro²Ri²/r² − (3+ν)r²]'],
          ['',                    ''],
          ['σ_θ is maximum at:',  'r = Ri  (inner bore)'],
          ['σ_r is maximum at:',  'r ≈ √(Ro·Ri)  (geometric mean)'],
          ['',                    ''],
          ['Burst speed:',        'ω_burst = √(σ_UTS / (Ky · ρ · Ro²))'],
          ['',                    'Ky ≈ 0.5–0.7 (shape constant)'],
          ['',                    ''],
          ['Tip speed limit:',    'v_tip = ω · Ro   (m/s)'],
          ['  Steel flywheel:',   '≤ 300–400 m/s (stress limited)'],
          ['  CFRP flywheel:',    '≤ 600–900 m/s (higher σ_UTS/ρ)'],
          ['',                    ''],
          ['Safety factor:',      'SF = σ_yield / σ_max  ≥ 2–3'],
          ['  Fatigue:',          'Consider σ_endurance (N > 10⁷ cycles)'],
          ['',                    ''],
          ['Material merit:',     'σ_UTS / ρ   (specific strength)'],
          ['  CFRP:',             '~2000 MPa / 1600 kg/m³ = 1.25 MJ/kg'],
          ['  Steel:',            '~800 MPa / 7800 kg/m³ = 0.10 MJ/kg'],
        ].map(([l,v],i)=>(
          <g key={i}>
            <text x={540} y={68+i*12.5} fontSize="9.5" fontWeight={l?'700':'400'} fill="#7a2e00">{l}</text>
            <text x={l?672:546} y={68+i*12.5} fontSize="9.5" fontFamily="'Courier New',monospace" fill="#a04010">{v}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Hoop stress is always greater than radial stress and peaks at the bore — this is why the bore diameter and inner radius are the critical design features for flywheel structural integrity</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 5 — Material comparison: specific energy density
// ─────────────────────────────────────────────────────────────────────────────
function DiagramMaterials() {
  const W=980, H=320;

  const materials = [
    { name:'Cast Iron',       density:7200, sigma:200,  color:'#7a4a28', E:210 },
    { name:'Steel (mild)',    density:7800, sigma:370,  color:'#a04010', E:210 },
    { name:'Steel (alloy)',   density:7850, sigma:800,  color:'#c45a10', E:210 },
    { name:'Maraging Steel',  density:8000, sigma:2000, color:'#d4874a', E:190 },
    { name:'Aluminium 7075',  density:2800, sigma:500,  color:'#c4a010', E:72  },
    { name:'Titanium 6Al-4V', density:4430, sigma:900,  color:'#8a6020', E:114 },
    { name:'E-Glass/Epoxy',   density:2100, sigma:1100, color:'#5a7820', E:40  },
    { name:'Carbon/Epoxy',    density:1600, sigma:2000, color:'#2a6020', E:135 },
  ];

  // Specific energy = σ/(2ρ) in kJ/kg (shape factor K=0.5 for solid disc)
  const specEnergy = materials.map(m=>({ ...m, se: (m.sigma*1e6)/(2*m.density*1000) }));
  const maxSE = Math.max(...specEnergy.map(m=>m.se));

  const barH=26, gap=6;
  const leftX=200, rightEdge=660;  // reduced from 700 to give label room before panel
  const barScale=(rightEdge-leftX)/maxSE;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Material Comparison — Specific Energy Density  ·  E_specific = σ_UTS / (2ρ)  ·  [kJ/kg]</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* X axis label below grid */}
        <text x={(leftX+rightEdge)/2} y={H-14} textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#7a2e00">Specific energy (kJ/kg)</text>
        <line x1={leftX-2} y1={14} x2={leftX-2} y2={H-28} stroke="#e8b07a" strokeWidth="1.5"/>

        {specEnergy.map((m,i)=>{
          const y = 20 + i*(barH+gap);
          const bw = Math.min(m.se * barScale, rightEdge-leftX);  // cap at rightEdge
          return (
            <g key={i}>
              <text x={leftX-8} y={y+barH*0.7} textAnchor="end" fontSize="9.5" fontWeight="700" fill="#7a2e00">{m.name}</text>
              <rect x={leftX} y={y} width={bw} height={barH} rx={3}
                fill={m.color} stroke="#7a2e00" strokeWidth="1.2" opacity="0.88"/>
              {/* Value label: inside bar if bar is wide enough, otherwise just after */}
              <text x={Math.min(leftX+bw+6, rightEdge+6)} y={y+barH*0.7}
                fontSize="9.5" fontWeight="700" fill={m.color}>
                {m.se.toFixed(0)} kJ/kg
              </text>
            </g>
          );
        })}

        {/* Grid lines */}
        {[0,50,100,150,200,250,300,350,400].map(v=>{
          const x=leftX+v*barScale;
          if(x>rightEdge+8) return null;
          return <g key={v}>
            <line x1={x} y1={14} x2={x} y2={H-28} stroke="#e8b07a" strokeWidth="0.8" strokeDasharray="3,3"/>
            <text x={x} y={H-28} textAnchor="middle" fontSize="8.5" fill="#7a4a28">{v}</text>
          </g>;
        })}

        {/* Right panel — at x=720, width=252 → right edge 972, well within 980 */}
        <rect x={720} y={14} width={252} height={H-28} rx={5} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={846} y={32} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Material Choice Factors</text>
        <line x1={728} y1={40} x2={964} y2={40} stroke="#e8b07a"/>
        {[
          'σ_UTS/ρ: primary metric',
          'Cost & availability',
          'Fatigue life (N cycles)',
          'Machinability / layup',
          'Temperature range',
          'Joining method (shaft)',
          'Containment on burst',
          '',
          'Steel: proven, cheap,',
          '  easy to machine',
          '',
          'CFRP: 10–15× higher',
          '  specific energy vs',
          '  steel — used for',
          '  high-speed FESS',
          '',
          'Note: shape factor K',
          '  (0.5 disc, 1.0 ring)',
          '  multiplies E_specific',
        ].map((line,i)=>(
          <text key={i} x={730} y={54+i*13.5} fontSize="9" fill={line.startsWith(' ')?'#a04010':'#7a2e00'}
            fontWeight={line.endsWith(':')||line.startsWith('Note:')?'700':'400'}>{line}</text>
        ))}
      </svg>
      <div style={S.dCaption}>Carbon-fibre composites achieve 12–15× the specific energy of mild steel — the practical limit for steel flywheels is ~5 Wh/kg; CFRP flywheel energy storage systems (FESS) reach 40–100 Wh/kg</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 6 — Flywheel types and applications: 4 design cards
// ─────────────────────────────────────────────────────────────────────────────
function DiagramTypes() {
  const W=980, H=310;

  const types = [
    { title:'Solid Steel Disc',
      color:'#a04010',
      specs:['Use: engine crankshafts, punch presses',
             'Speed: 500–3000 RPM',
             'Energy: 0.1–5 Wh/kg',
             'I-shape: high (mass at rim)',
             'Pros: robust, cheap, proven',
             'Cons: heavy, limited speed'],
      drawR: 60,
      draw: (cx,cy,r)=> <>
        <circle cx={cx} cy={cy} r={r}  fill="#d4874a" stroke="#7a2e00" strokeWidth="3"/>
        <circle cx={cx} cy={cy} r={14} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={cx} cy={cy} r={6}  fill="#fdf0e4" stroke="#5a1e00" strokeWidth="1.5"/>
      </> },
    { title:'Rim-Weighted / Spoked',
      color:'#c45a10',
      specs:['Use: reciprocating engines, generators',
             'Speed: 300–1500 RPM',
             'Energy: 0.3–10 Wh/kg',
             'I-shape: very high (mass at rim)',
             'Pros: high I per mass',
             'Cons: harder to balance'],
      drawR: 60,
      draw: (cx,cy,r)=> <>
        {Array.from({length:8},(_,i)=>{
          const a=i*Math.PI/4;
          return <line key={i} x1={cx+10*Math.cos(a)} y1={cy+10*Math.sin(a)}
            x2={cx+(r-10)*Math.cos(a)} y2={cy+(r-10)*Math.sin(a)}
            stroke="#c45a10" strokeWidth="8" strokeLinecap="round"/>;
        })}
        <circle cx={cx} cy={cy} r={r}  fill="none" stroke="#7a2e00" strokeWidth="20"/>
        <circle cx={cx} cy={cy} r={r}  fill="none" stroke="#d4874a" strokeWidth="16"/>
        <circle cx={cx} cy={cy} r={16} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={cx} cy={cy} r={7}  fill="#fdf0e4" stroke="#5a1e00" strokeWidth="1.5"/>
      </> },
    { title:'CFRP High-Speed',
      color:'#5a7820',
      specs:['Use: UPS, grid storage (FESS)',
             'Speed: 20,000–60,000 RPM',
             'Energy: 20–100 Wh/kg',
             'Housing: vacuum + mag. bearing',
             'Pros: very high energy density',
             'Cons: expensive, containment req.'],
      drawR: 60,
      draw: (cx,cy,r)=> <>
        <circle cx={cx} cy={cy} r={r+12} fill="#fdf0e4" stroke="#5a7820" strokeWidth="1.5" strokeDasharray="4,3"/>
        <circle cx={cx} cy={cy} r={r}    fill="none" stroke="#5a7820" strokeWidth="18"/>
        <circle cx={cx} cy={cy} r={r}    fill="none" stroke="#a0c020" strokeWidth="14"/>
        {Array.from({length:5},(_,i)=>{
          const a=i*2*Math.PI/5;
          return <line key={i} x1={cx} y1={cy} x2={cx+r*0.7*Math.cos(a)} y2={cy+r*0.7*Math.sin(a)}
            stroke="#8a1010" strokeWidth="3" opacity="0.4"/>;
        })}
        <circle cx={cx} cy={cy} r={12}   fill="#5a7820" stroke="#3a5010" strokeWidth="2"/>
        <circle cx={cx} cy={cy} r={5}    fill="#fdf0e4"/>
        <text x={cx+r+16} y={cy-r/2}    fontSize="7.5" fill="#5a7820">vacuum</text>
        <text x={cx+r+16} y={cy-r/2+11} fontSize="7.5" fill="#5a7820">housing</text>
      </> },
    { title:'Dual-Mass / Torsional',
      color:'#7a2e00',
      specs:['Use: automotive dual-mass DMF',
             'Speed: 800–6000 RPM (engine)',
             'Energy: absorbs torsional pulses',
             'Mechanism: spring-damper coupling',
             'Pros: isolates drivetrain vibration',
             'Cons: complex, wear-prone springs'],
      drawR: 60,
      draw: (cx,cy,r)=> <>
        <circle cx={cx-10} cy={cy} r={r*0.7} fill="#d4874a" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={cx+10} cy={cy} r={r*0.7} fill="#c45a10" stroke="#7a2e00" strokeWidth="2.5" opacity="0.8"/>
        <circle cx={cx-10} cy={cy} r={9}     fill="#7a2e00" stroke="#5a1e00" strokeWidth="1.5"/>
        <circle cx={cx+10} cy={cy} r={9}     fill="#7a2e00" stroke="#5a1e00" strokeWidth="1.5"/>
        {[-1,1].map(s=>(
          <g key={s}>
            <rect x={cx+s*4} y={cy-6} width={14} height={12} rx={3}
              fill="#e8b07a" stroke="#a04010" strokeWidth="1.5"/>
          </g>
        ))}
        <text x={cx} y={cy+r*0.7+18} textAnchor="middle" fontSize="7.5" fill="#7a2e00">spring-damper</text>
      </> },
  ];

  const cw=W/types.length;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Flywheel Types &amp; Applications — Solid · Spoked · CFRP High-Speed · Dual-Mass</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {types.map((t,i)=>{
          const cx=cw*i+cw/2, cy=96;
          // Use series palette for all cards
          const headerColor=['#a04010','#c45a10','#7a4a28','#7a2e00'][i];
          return (
            <g key={i}>
              {/* Card background */}
              <rect x={cw*i+4} y={4} width={cw-8} height={H-8} rx={6}
                fill={i%2===0?'#fdf4ec':'#fdf0e4'} stroke={headerColor} strokeWidth="1.8"/>
              {/* Header */}
              <rect x={cw*i+4} y={4}  width={cw-8} height={34} rx={6} fill={headerColor} stroke="none"/>
              <rect x={cw*i+4} y={28} width={cw-8} height={10}  fill={headerColor} stroke="none"/>
              <text x={cx} y={25} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fdf4ec">{t.title}</text>
              {/* Draw flywheel graphic */}
              {t.draw(cx, cy, t.drawR)}
              {/* Specs */}
              {t.specs.map((sp,j)=>{
                const colonIdx=sp.indexOf(': ');
                const label=colonIdx>-1?sp.slice(0,colonIdx):'';
                const value=colonIdx>-1?sp.slice(colonIdx+2):sp;
                return (
                  <g key={j}>
                    <text x={cw*i+14} y={174+j*20} fontSize="9.5" fontWeight="700" fill="#7a2e00">{label}{label?':':''}</text>
                    <text x={cw*i+14} y={186+j*20} fontSize="9.5" fill="#a04010" fontFamily="'Courier New',monospace">{value}</text>
                  </g>
                );
              })}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>CFRP flywheels in vacuum enclosures with magnetic bearings (zero friction) achieve self-discharge rates under 5% per hour and are increasingly used for grid frequency regulation and UPS applications</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 7 — Bearing friction and efficiency: loss vs. speed for 3 bearing types
// ─────────────────────────────────────────────────────────────────────────────
function DiagramBearingLoss() {
  const W=980, H=310;
  const chartX=55, chartY=20, chartW=450, chartH=240;
  const baseY=chartY+chartH;
  const maxRPM=60000, maxLoss=100;

  const bearings = [
    { label:'Ball bearing (steel)',    color:'#c45a10', μ:0.0015, note:'Std FESS' },
    { label:'Hydrodynamic (oil film)', color:'#a04010', μ:0.001,  note:'Large machines' },
    { label:'Magnetic (active AMB)',   color:'#5a7820', μ:0.00005,note:'High-speed CFRP' },
    { label:'Vacuum + AMB',            color:'#2a6020', μ:0.000005, note:'Grid storage FESS' },
  ];

  // Power loss ≈ μ × F_normal × v_tip = μ × m × g × ω × r (simplified model)
  // Normalised: loss = μ × (RPM/1000)²  × 10
  function loss(rpm, μ) { return μ * (rpm/1000)*(rpm/1000) * 10 * 1000; }

  const speeds = Array.from({length:100},(_,i)=>i*(maxRPM/99));

  function toX(rpm) { return chartX + (rpm/maxRPM)*chartW; }
  function toY(L)   { return baseY - Math.min(L,maxLoss)/maxLoss*chartH; }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Bearing Losses vs. Speed — Ball Bearing · Hydrodynamic · Active Magnetic (AMB) · Vacuum AMB</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>{arrowDef('arBL')}</defs>

        <rect x={chartX} y={chartY} width={chartW} height={chartH}
          fill="#fdf0e4" stroke="#e8b07a" strokeWidth="1.5" rx={4}/>

        {/* Grid */}
        {[0,20,40,60,80,100].map(v=>{
          const y=toY(v);
          return <g key={v}>
            <line x1={chartX} y1={y} x2={chartX+chartW} y2={y}
              stroke="#e8b07a" strokeWidth="0.8" strokeDasharray="4,3"/>
            <text x={chartX-6} y={y+4} textAnchor="end" fontSize="9" fill="#7a4a28">{v}</text>
          </g>;
        })}
        {[0,15000,30000,45000,60000].map(v=>(
          <text key={v} x={toX(v)} y={baseY+16} textAnchor="middle" fontSize="9" fill="#7a4a28">
            {v===0?'0':(v/1000)+'k'}
          </text>
        ))}

        <text x={chartX+chartW/2} y={baseY+30} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Speed (RPM)</text>
        <text x={chartX-42} y={chartY+chartH/2} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00"
          transform={`rotate(-90,${chartX-42},${chartY+chartH/2})`}>Power loss (W, normalised)</text>

        {/* Curves */}
        {bearings.map((b,bi)=>{
          const pts=speeds.map(rpm=>`${toX(rpm).toFixed(1)},${toY(loss(rpm,b.μ)).toFixed(1)}`);
          return <path key={bi} d={'M '+pts.join(' L ')}
            fill="none" stroke={b.color} strokeWidth="2.5" opacity="0.9"/>;
        })}

        {/* End labels on curves */}
        {bearings.map((b,bi)=>{
          const lastRPM=maxRPM;
          const y=toY(loss(lastRPM, b.μ));
          if(y < chartY+8) return null;
          return (
            <text key={bi} x={toX(lastRPM)+6} y={Math.max(chartY+10, y+4)}
              fontSize="9.5" fontWeight="700" fill={b.color}>{b.label}</text>
          );
        })}

        {/* Right panel */}
        <rect x={530} y={14} width={438} height={H-20} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={749} y={34} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Bearing Technology</text>
        <line x1={538} y1={42} x2={960} y2={42} stroke="#e8b07a"/>
        {[
          ['Ball bearing:',      'μ ≈ 0.001–0.003'],
          ['',                   'Max speed: ~15,000 RPM'],
          ['',                   'Cost: low · Maintenance: grease'],
          ['',                   ''],
          ['Hydrodynamic:',      'μ ≈ 0.001 (speed-dependent)'],
          ['',                   'Self-forming oil wedge film'],
          ['',                   'Best at high speed / load'],
          ['',                   ''],
          ['Active Magnetic:',   'μ ≈ 0.00005 (friction-free)'],
          ['(AMB)',               'Electromagnets levitate rotor'],
          ['',                   'Requires power & control loop'],
          ['',                   'Max speed: 100,000+ RPM'],
          ['',                   ''],
          ['Vacuum AMB:',        'Air drag removed → μ < 0.000005'],
          ['',                   'Self-discharge < 3–5%/hour'],
          ['',                   'Used in grid FESS & satellites'],
          ['',                   ''],
          ['Self-discharge:',    'E(t) = E₀ · e^(−t/τ)'],
          ['',                   'τ = I·ω / (2·P_loss)'],
        ].map(([l,v],i)=>(
          <g key={i}>
            <text x={540} y={56+i*13} fontSize="9.5" fontWeight={l?'700':'400'} fill="#7a2e00">{l}</text>
            <text x={l?658:546} y={56+i*13} fontSize="9.5" fontFamily="'Courier New',monospace" fill="#a04010">{v}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Active magnetic bearings eliminate contact friction entirely — combined with a vacuum housing they reduce standby losses by 99% compared to a grease-lubricated ball bearing at the same speed</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 8 — Flywheel energy storage vs. batteries & capacitors (Ragone plot)
// ─────────────────────────────────────────────────────────────────────────────
function DiagramRagone() {
  const W=980, H=360;
  const chartX=70, chartY=20, chartW=540, chartH=290;
  const baseY=chartY+chartH;

  // Log-log Ragone plot: x=specific power (W/kg), y=specific energy (Wh/kg)
  const devices = [
    { name:'Lead-acid battery',    Wh:[20,40],    W:[50,200],     color:'#7a4a28' },
    { name:'Li-ion battery',       Wh:[100,250],  W:[200,1500],   color:'#c45a10' },
    { name:'EDLC supercapacitor',  Wh:[2,10],     W:[1000,10000], color:'#5a7820' },
    { name:'Steel flywheel',       Wh:[1,5],      W:[400,5000],   color:'#a04010' },
    { name:'CFRP flywheel',        Wh:[20,100],   W:[2000,50000], color:'#2a6020' },
    { name:'Li-S battery',         Wh:[250,500],  W:[100,500],    color:'#8a6020' },
  ];

  const xMin=1, xMax=100000, yMin=0.5, yMax=1000;

  function logX(v) { return chartX + Math.log10(v/xMin)/Math.log10(xMax/xMin)*chartW; }
  function logY(v) { return baseY  - Math.log10(v/yMin)/Math.log10(yMax/yMin)*chartH; }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Ragone Plot — Specific Energy vs. Specific Power  ·  Flywheel vs. Battery vs. Supercapacitor</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>{arrowDef('arRG')}</defs>

        {/* Chart */}
        <rect x={chartX} y={chartY} width={chartW} height={chartH}
          fill="#fdf0e4" stroke="#e8b07a" strokeWidth="1.5" rx={4}/>

        {/* Log grid */}
        {[1,10,100,1000,10000,100000].map(v=>{
          const x=logX(v);
          return <g key={v}>
            <line x1={x} y1={chartY} x2={x} y2={baseY}
              stroke="#e8b07a" strokeWidth="0.8" strokeDasharray="4,3"/>
            <text x={x} y={baseY+16} textAnchor="middle" fontSize="9" fill="#7a4a28">
              {v>=1000?(v/1000)+'k':v}
            </text>
          </g>;
        })}
        {[0.5,1,5,10,50,100,500,1000].map(v=>{
          const y=logY(v);
          if(y<chartY) return null;
          return <g key={v}>
            <line x1={chartX} y1={y} x2={chartX+chartW} y2={y}
              stroke="#e8b07a" strokeWidth="0.8" strokeDasharray="4,3"/>
            <text x={chartX-6} y={y+4} textAnchor="end" fontSize="9" fill="#7a4a28">{v}</text>
          </g>;
        })}

        {/* Axes */}
        <text x={chartX+chartW/2} y={baseY+32} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Specific Power (W/kg)  [log scale]</text>
        <text x={chartX-50} y={chartY+chartH/2} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00"
          transform={`rotate(-90,${chartX-50},${chartY+chartH/2})`}>Specific Energy (Wh/kg)  [log scale]</text>

        {/* Device ellipses */}
        {devices.map((d,i)=>{
          const x1=logX(d.W[0]),   x2=logX(d.W[1]);
          const y1=logY(d.Wh[1]),  y2=logY(d.Wh[0]);
          const rx=(x2-x1)/2+6, ry=(y2-y1)/2+6;
          const cxEl=(x1+x2)/2,   cyEl=(y1+y2)/2;
          return (
            <g key={i}>
              <ellipse cx={cxEl} cy={cyEl} rx={rx} ry={ry}
                fill={d.color} stroke={d.color} strokeWidth="2" opacity="0.25"/>
              <ellipse cx={cxEl} cy={cyEl} rx={rx} ry={ry}
                fill="none" stroke={d.color} strokeWidth="2"/>
              <text x={cxEl} y={cyEl+4} textAnchor="middle"
                fontSize="8.5" fontWeight="700" fill={d.color}>{d.name}</text>
            </g>
          );
        })}

        {/* Right legend panel */}
        <rect x={640} y={20} width={330} height={H-32} rx={5} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={805} y={40} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Technology Comparison</text>
        <line x1={648} y1={48} x2={962} y2={48} stroke="#e8b07a"/>
        {[
          ['Steel FESS:',    '1–5 Wh/kg, 5 kW/kg'],
          ['',               'Cycle life: >100,000'],
          ['',               'Efficiency: 85–90%'],
          ['',               ''],
          ['CFRP FESS:',     '20–100 Wh/kg, 50 kW/kg'],
          ['',               'Cycle life: unlimited'],
          ['',               'Efficiency: 95%+'],
          ['',               ''],
          ['Li-ion:',        '100–250 Wh/kg, 0.3 kW/kg'],
          ['',               'Cycle life: 500–2000'],
          ['',               'Efficiency: 90–97%'],
          ['',               ''],
          ['EDLC cap:',      '2–10 Wh/kg, 5 kW/kg'],
          ['',               'Cycle life: >1,000,000'],
          ['',               'Efficiency: >98%'],
          ['',               ''],
          ['Flywheel niche:','Fast charge/discharge,'],
          ['',               'unlimited cycles, no'],
          ['',               'chemical degradation'],
        ].map(([l,v],i)=>(
          <g key={i}>
            <text x={652} y={62+i*14} fontSize="9.5" fontWeight={l?'700':'400'} fill="#7a2e00">{l}</text>
            <text x={l?742:658} y={62+i*14} fontSize="9.5" fontFamily="'Courier New',monospace" fill="#a04010">{v}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>CFRP flywheels occupy a unique niche — higher power than batteries, more energy than supercapacitors, and essentially infinite cycle life; they are ideal for frequency regulation and UPS where fast discharge at high power is required</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DIAGRAM 9 — Design procedure flowchart
// ─────────────────────────────────────────────────────────────────────────────
function DiagramDesignFlow() {
  const W=980, H=320;
  const bw=110, bh=58, byTop=40;

  const steps = [
    { label:'Define\nRequirements', sub:'ΔE, Cs, ω_mean\nspace & weight' },
    { label:'Calculate\nRequired I',  sub:'I = ΔE/(Cs·ω²)\nfrom spec' },
    { label:'Choose\nMaterial',       sub:'σ_UTS/ρ\noperating temp' },
    { label:'Determine\nGeometry',    sub:'Ro, Ri, width b\nfrom I formula' },
    { label:'Stress\nCheck',          sub:'σ_hoop < σ_allow\nSF ≥ 2' },
    { label:'Bearing &\nSealing',     sub:'Type, μ\nvacuum?' },
    { label:'Containment\n& Safety',  sub:'Burst shield\nregulation' },
  ];

  const spacing = (W - bw) / (steps.length - 1);
  const centres = steps.map((_,i)=> bw/2 + i*spacing);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Flywheel Design Procedure — Seven-Step Flow with Decision Points</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          {arrowDef('arDF')}
          {arrowDef('arDFr','#7a2e00')}
        </defs>

        {steps.map((step,i)=>{
          const cx=centres[i];
          const bx=cx-bw/2;
          const fill=['#d4874a','#c45a10','#c45a10','#c45a10','#a04010','#a04010','#7a2e00'][i];
          return (
            <g key={i}>
              <rect x={bx} y={byTop} width={bw} height={bh} rx={7}
                fill={fill} stroke="#5a1e00" strokeWidth="2"/>
              <circle cx={bx+11} cy={byTop+11} r={9} fill="#fdf0e4" stroke="#5a1e00" strokeWidth="1.5"/>
              <text x={bx+11} y={byTop+15} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">{i+1}</text>
              {step.label.split('\n').map((l,j)=>(
                <text key={j} x={cx} y={byTop+24+j*16} textAnchor="middle"
                  fontSize="10.5" fontWeight="700" fill="#fdf4ec">{l}</text>
              ))}
              {step.sub.split('\n').map((s,j)=>(
                <text key={j} x={cx} y={byTop+bh+16+j*14} textAnchor="middle"
                  fontSize="9" fill="#7a4a28">{s}</text>
              ))}
              {i < steps.length-1 && (
                <line x1={bx+bw+4} y1={byTop+bh/2}
                  x2={centres[i+1]-bw/2-5} y2={byTop+bh/2}
                  stroke="#c45a10" strokeWidth="2.5" markerEnd="url(#arDF)"/>
              )}
            </g>
          );
        })}

        {/* Feedback arc from Stress Check back to Choose Material */}
        <path d={`M ${centres[4]} ${byTop+bh+2} Q ${centres[4]} ${H-32} ${centres[3]} ${H-32} Q ${centres[2]} ${H-32} ${centres[2]} ${byTop+bh+2}`}
          fill="none" stroke="#7a2e00" strokeWidth="1.8" strokeDasharray="7,4"
          markerEnd="url(#arDFr)"/>
        <rect x={centres[3]-80} y={H-30} width={160} height={22} rx={4}
          fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={centres[3]} y={H-15} textAnchor="middle" fontSize="9.5" fontWeight="700" fill="#7a2e00">
          Fail → revise geometry or material
        </text>
      </svg>
      <div style={S.dCaption}>The design loop between geometry determination and stress check is critical — increasing Ro raises I but also increases hoop stress; the material's specific strength σ/ρ governs the achievable energy density</div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ROOT COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
export default function FlywheelsPage() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Flywheels — Mechanical Engineering Reference</h1>

      <p style={S.p}>
        A <strong>flywheel</strong> is a rotating mechanical device that stores kinetic energy in its
        spinning mass. It resists changes in rotational speed by virtue of its <em>moment of inertia</em>,
        acting as a short-term mechanical energy buffer. Historically used to smooth the output of
        reciprocating steam engines and punch presses, flywheels now appear in precision manufacturing
        equipment, automotive dual-mass systems, spacecraft attitude control, and large-scale grid energy
        storage — where carbon-fibre composite rotors spinning at 50,000 RPM in vacuum enclosures can
        store over 100 Wh/kg with essentially unlimited charge-discharge cycles.
      </p>

      <h2 style={S.h2}>Anatomy &amp; Geometry</h2>
      <p style={S.p}>
        A flywheel is divided into three functional zones: the <strong>rim</strong> (where most stored
        energy resides), the <strong>web or spokes</strong> (which transfer torque between rim and hub),
        and the <strong>hub</strong> (which couples the flywheel to the shaft). Concentrating mass at
        maximum radius maximises the moment of inertia I for a given total mass, since I&nbsp;∝&nbsp;r².
      </p>
      <DiagramAnatomy />
      <Table2 rows={[
        ['Moment of inertia','I = ∫ r² dm   (fundamental definition)\nFor a solid cylinder:  I = ½mR²\nFor a thin ring:        I = mR²\nFor a hollow cylinder: I = ½m(Ro²+Ri²)\nFor annular disc (Ro/Ri = k): I = ½m·Ro²·(1+k²)'],
        ['Radius of gyration','k_g = √(I/m)  [m] — equivalent radius of a point mass\nSolid disc: k_g = R/√2 = 0.707R\nThin ring:  k_g = R\nHollow (Ri=0.7Ro): k_g ≈ 0.87R'],
        ['Key dimensions','Ro = outer radius (m)  ·  Ri = inner bore radius (m)\nb = axial width (m)   ·  ρ = material density (kg/m³)\nFor solid disc: I = ½ · π·ρ·b · Ro⁴\nFor annulus:    I = ½ · π·ρ·b · (Ro⁴−Ri⁴)'],
        ['Polar moment','J = 2·I   (for flat disc, polar second moment of area)\nTorsional stiffness: k_T = G·J/L  (shaft design)\nThe flywheel adds J directly to the drivetrain inertia'],
        ['Rim vs disc tradeoff','Spoked/rim-weighted: higher I per kg — more mass at Ro\nSolid disc: easier to manufacture, better for high-speed\nDesign rule: maximise Ro within stress and space limits\nRim width t_rim ≈ 0.05–0.15 × Ro (structural minimum)'],
      ]}/>

      <h2 style={S.h2}>Moment of Inertia — Geometry Comparison</h2>
      <DiagramMomentOfInertia />
      <Table2 rows={[
        ['Shape factor K','E_stored = K · σ_max/ρ · m  (maximum specific energy)\nK = 0.5 for solid disc (Laval/isotropic)\nK = 1.0 for thin ring (all mass at rim)\nK ≈ 0.6–0.9 for practical spoked designs\nK depends on geometry and anisotropy (CFRP: K varies by layup)'],
        ['Parallel axis theorem','I_total = I_cm + m·d²  (shifting spin axis by distance d)\nUsed when flywheel is offset from its centre of mass\nIn drivetrains: add I of each rotating part about the central shaft axis\nGearbox ratio squares the inertia: I_reflected = I_flywheel / N²'],
        ['Stretch goal: thin ring','I_ring = mR² → E/m = ½ω²R² = ½v_tip²\nMaximum stored energy is entirely determined by tip speed\nAll flywheel designs converge to this limit: maximise v_tip\nv_tip limit set by material strength, not geometry'],
      ]}/>

      <h2 style={S.h2}>Energy Storage &amp; Torque Smoothing</h2>
      <p style={S.p}>
        In reciprocating engine applications, the flywheel absorbs kinetic energy during the power stroke
        (when engine torque exceeds load) and returns it during the exhaust, intake, and compression
        strokes. The <em>coefficient of fluctuation of speed</em> Cs is the key design parameter linking
        required energy storage ΔE to allowable speed variation.
      </p>
      <DiagramEnergySmoothing />
      <Table2 rows={[
        ['Coefficient of fluctuation','Cs = (ω_max − ω_min) / ω_mean\nTypical values:\n  Crushing machines:      0.200\n  Machine tools:          0.020–0.030\n  Pumps and compressors:  0.010–0.020\n  Generators (AC):        0.003–0.005\n  Steam turbines:         0.002'],
        ['Energy fluctuation ΔE','ΔE = I · ω_mean · Δω = I · ω_mean² · Cs\nΔE = area between engine torque curve and load line (T vs θ graph)\nComputed by integrating the torque excess/deficit over one cycle\nFor single-cylinder 4-stroke: ΔE ≈ 0.3–0.7 × mean torque × 4π'],
        ['Required flywheel I','I = ΔE / (Cs · ω_mean²)\nThis is the primary design equation: specify Cs, compute I\nThen choose material and geometry to achieve that I within mass and space budgets\nHigher ω_mean: smaller I needed for same Cs — high-speed designs are lighter'],
        ['Angular impulse method','ΔE = ∫ T_net dθ  (area between torque curve and load line)\nFor punch press: ΔE = F × stroke (N·m punch work per cycle)\nDriving torque curve requires indicator diagram or simulation\nSingle-cylinder 4-stroke engine: one power pulse per 720° of crank rotation'],
        ['Multi-cylinder engines','N cylinders: each fires at 720°/N crank rotation intervals\n4-cylinder: power pulses every 180° → much smaller ΔE → smaller flywheel\n6-cylinder inline: pulses every 120° → very smooth\nV8: effectively 90° intervals → flywheel nearly unnecessary for smoothing'],
      ]}/>

      <h2 style={S.h2}>Stress Analysis &amp; Burst Speed</h2>
      <DiagramStress />
      <Table2 rows={[
        ['Hoop (circumferential) stress','σ_θ = ρω²/8 · [(3+ν)(Ro²+Ri²) + Ro²Ri²/r² − (1+3ν)r²]\nPeaks at r = Ri (bore edge) for disc with bore\nFor solid disc with no bore: max σ_θ = ρω²(3+ν)/8 · Ro²  (at centre)\nHoop stress is ALWAYS ≥ radial stress at every radius'],
        ['Radial stress','σ_r = ρω²/8 · [(3+ν)(Ro²+Ri²) − Ro²Ri²/r² − (3+ν)r²]\nσ_r = 0 at free surfaces (r=Ri and r=Ro) — boundary condition\nMaximum σ_r occurs at r = √(Ro·Ri) (geometric mean radius)\nσ_r_max = ρω²(3+ν)/8 · (Ro−Ri)² (annular disc)'],
        ['Von Mises criterion','σ_VM = √(σ_θ² − σ_θ·σ_r + σ_r²)  (biaxial state)\nUse σ_VM < σ_yield/SF for ductile materials\nFor brittle materials (cast iron): use maximum principal stress criterion\nSafety factor SF ≥ 2 at operating speed; SF ≥ 1.2 at burst speed'],
        ['Burst speed','ω_burst = √(σ_burst / (Ky · ρ · Ro²))\nKy ≈ 0.5–0.7 (empirical shape factor for burst)\nσ_burst = ultimate tensile strength of material\nDesign rule: ω_operating < ω_burst / SF  (SF = 2 typical)'],
        ['Interference fit (hub)','Press-fit or shrink-fit hub modifies stress distribution\nAssembly hoop stress at hub: σ_θ = E·δ·Ri / (Ro²−Ri²) (Lame)\nδ = radial interference (m)   E = modulus (Pa)\nSuperpose assembly stress and centrifugal stress at all speeds'],
        ['Fatigue considerations','Flywheels cycle every engine revolution → 10⁶–10⁹ cycles in service\nEndurance limit σ_e ≈ 0.4–0.5 × σ_UTS for steels\nStress concentration at bore, keyway, spokes: Kt = 1.5–3.0\nDesign to σ_max < σ_e / (Kt × SF_fatigue) with SF_fatigue ≥ 1.5'],
      ]}/>

      <h2 style={S.h2}>Materials</h2>
      <DiagramMaterials />
      <Table2 rows={[
        ['Specific energy merit','E/m = K · σ_UTS / (2ρ)   [J/kg]\nK = shape factor (0.5 for disc, 1.0 for ring)\nHigher σ_UTS/ρ (specific strength) → more energy per kg\nThis is why CFRP, Ti, and maraging steel beat plain carbon steel'],
        ['Cast iron','ρ ≈ 7200 kg/m³  ·  σ_UTS ≈ 200–350 MPa\nGood vibration damping (graphite flakes)\nBrittle: fails without warning — careful SF required\nLow cost: still common for heavy industrial flywheels'],
        ['Alloy steel','ρ ≈ 7800–7900 kg/m³  ·  σ_UTS = 600–1200 MPa\nTough, machinable, weldable\nFatigue endurance: ~400–600 MPa\n4340, 300M, 17-4PH common for high-speed steel flywheels'],
        ['Maraging steel','ρ ≈ 8000 kg/m³  ·  σ_UTS ≈ 1800–2400 MPa\nVery high strength with good toughness\nMinimal machining distortion (low carbon)\nUsed for highest-performance steel FESS (up to ~400 Wh/kg tip speed limit)'],
        ['Carbon fibre (CFRP)','ρ ≈ 1500–1600 kg/m³  ·  σ_UTS ≈ 1500–3000 MPa (hoop direction)\nSpecific energy 12–15× steel — allows much higher tip speed\nAnisotropic: must design fibre orientation for hoop loading\nContainment critical: CFRP shatters into fine powder on burst (lower impact energy than steel fragments)'],
        ['Aluminium alloys','ρ ≈ 2700–2800 kg/m³  ·  σ_UTS ≈ 400–570 MPa\nσ_UTS/ρ ≈ 200 kJ/kg — better than mild steel\nGood machinability, corrosion resistance\nUsed where weight is critical but CFRP cost is not justified'],
        ['Temperature effects','High-speed flywheels heat from bearing friction and windage\nMaterial strength decreases with temperature: σ_UTS drops 30–50% at 300°C\nFor high-cycle applications: fatigue curve shifts down with temperature\nVacuum operation eliminates windage heating → allows higher speeds'],
      ]}/>

      <h2 style={S.h2}>Flywheel Types &amp; Applications</h2>
      <DiagramTypes />
      <Table2 rows={[
        ['Engine crankshaft flywheel','Resists speed fluctuation between power strokes\nMoment of inertia sized for Cs = 0.01–0.05\nAlso carries the clutch pressure plate (automotive)\nTypically cast iron or forged steel, 5–25 kg'],
        ['Punch press flywheel','Very large ΔE in a single stroke: flywheel stores energy over many cycles\nTypical Cs = 0.1–0.2 (large speed fluctuation accepted)\nLarge rim-weighted cast iron, 100–2000 kg\nMotor only needs to supply mean power, not peak punch force power'],
        ['Marine engine flywheel','Low speed (100–600 RPM), very high I needed for Cs target\nTypically 500–5000 kg, spoked construction\nAlso acts as turning gear for barring over the engine'],
        ['Dual-mass flywheel (DMF)','Automotive: isolates transmission from engine torsional vibrations\nTwo masses connected by springs and friction dampers\nPrimary mass on crankshaft; secondary mass on transmission\nReduces peak torsional load to transmission by 30–60%'],
        ['Flywheel energy storage (FESS)','Grid-scale: 250 kW to 20 MW systems; 10–100 Wh per unit\nVacuum housing + active magnetic bearings; CFRP rotor\nApplications: frequency regulation, peak shaving, UPS, rail regeneration\nCapex higher than batteries; much lower lifecycle cost per cycle'],
        ['Satellite reaction wheels','Small CFRP flywheels for attitude control (torquing satellite)\nTypically 2–20 kg, 3000–8000 RPM\nThree wheels (one per axis) + one skewed redundancy wheel\nSpeed commanded by control system to generate reaction torque'],
      ]}/>

      <h2 style={S.h2}>Bearings, Friction &amp; Losses</h2>
      <DiagramBearingLoss />
      <Table2 rows={[
        ['Power loss mechanism','Viscous drag in bearings: P = μ·F·v  (bearing surface velocity)\nAir drag (windage): P ∝ ρ_air·ω³·Ro⁵  (cube of speed — dominant at high RPM)\nSealing losses: labyrinth seals add friction\nAt high speed, windage dominates → vacuum enclosure essential above ~3000 RPM for efficiency'],
        ['Ball bearing selection','Bore × 5 = approximate shaft diameter (mm rule)\nL10 life:  L10 = (C/P)^p × 10^6 revolutions  (p=3 balls, p=10/3 roller)\nLoad rating C from catalogue; applied load P includes centrifugal loads\nPre-load for angular contact bearings prevents ball skidding at high speed'],
        ['Active magnetic bearings','5-axis control: 2 radial × 2 positions + 1 axial\nPower draw 1–5% of rated flywheel power (control electronics)\nSensor: eddy-current gap sensor, 0.1 μm resolution\nRequires backup (catcher) bearings for power failure'],
        ['Self-discharge rate','Steel flywheel, ball bearing, air: τ ≈ 2–6 hours\nCFRP flywheel, AMB, vacuum:   τ ≈ 20–100 hours\nE(t) = E₀ · exp(−t/τ)   τ = I·ω_mean / (2·P_loss)\nFor daily dispatch: even steel FESS is viable; for weekly storage: AMB+vacuum only'],
        ['Vacuum level requirement','P < 0.1 Pa (10⁻³ mbar): windage negligible for D < 0.5 m\nHigh-speed CFRP (v_tip > 400 m/s): P < 0.01 Pa required\nVacuum pump: turbomolecular + scroll backing pump\nHousing: all-welded stainless or Ti; O-ring feedthroughs for electrical leads'],
      ]}/>

      <h2 style={S.h2}>Energy Storage vs. Competing Technologies</h2>
      <DiagramRagone />
      <Table2 rows={[
        ['Cycle life advantage','Flywheel: effectively unlimited cycles (no chemical degradation)\nLi-ion: 500–2000 full cycles to 80% capacity\nLead-acid: 200–500 cycles\nFlywheel LCOE per cycle is much lower for high-frequency dispatch applications'],
        ['Round-trip efficiency','CFRP + AMB + vacuum: 90–95% round-trip\nSteel + ball bearing + air: 75–88% (higher losses)\nLi-ion: 90–97% (but capacity fades with cycles and temperature)\nSupercapacitor: 95–98% but very low energy density'],
        ['Response time','Flywheel: sub-millisecond (mechanical response, no switching)\nLi-ion: 100–200 ms (BMS and contactor switching)\nFlywheels for grid: can arrest frequency deviation before inverter-based storage reacts\nUsed in first-response frequency regulation (primary reserve)'],
        ['Temperature range','Flywheel: −40°C to +85°C (bearing lubricant limit)\nLi-ion: 0°C to 45°C optimal (capacity loss at extremes)\nFor Arctic / desert deployment: flywheel advantage significant\nAMB systems require more complex temperature compensation'],
        ['Safety & containment','On burst: steel flywheel → large metal fragments (high energy)\nCFRP flywheel → fibrous dust cloud (lower kinetic energy per fragment)\nDesign standard: containment ring must absorb full rotor kinetic energy\nMaterial: AR500 steel plate, 20–50 mm thick around rotor'],
        ['Grid storage economics','Capital cost: FESS ~$1000–3000/kW, $2000–10000/kWh\nLi-ion: ~$150–400/kWh (2024), dropping\nFlywheel advantage: revenue from frequency regulation (high cycles/year)\nBreakeven: >200–400 full cycles per year favours flywheel on lifecycle cost'],
      ]}/>

      <h2 style={S.h2}>Design Procedure</h2>
      <DiagramDesignFlow />
      <Table2 rows={[
        ['Step 1 — Requirements','State: ΔE (J), Cs (dimensionless), ω_mean (rad/s), life (cycles)\nAlso: max outer radius Ro, max mass m, operating temperature range\nFrom ΔE and Cs: I_required = ΔE / (Cs × ω_mean²)\nFrom m and Ro limits: check feasibility I_max = ½m·Ro²'],
        ['Step 2 — Material selection','Rank candidates by σ_UTS/ρ (specific strength)\nCheck: fatigue limit, temperature range, machinability, cost\nFor K · σ/ρ > I·ω_mean²/m: material meets specific energy requirement\nPreferred for industrial: 4340 steel · for high-perf: T700 carbon/epoxy'],
        ['Step 3 — Geometry calculation','Given I, material ρ, and geometric form (disc or ring):\nSolid disc: b = 2I / (π·ρ·Ro⁴)  → solve for b (width)\nAnnulus:    Ro and Ri from I = ½·π·ρ·b·(Ro⁴−Ri⁴)\nIterate: adjust Ro, Ri, b to meet I, mass, and size constraints'],
        ['Step 4 — Stress analysis','Compute σ_θ_max using Lame equations at ω_max = ω_mean × (1 + Cs/2)\nFor bore: σ_θ = ρω²/4 × (Ro²+Ri²) · (3+ν)/2  (simplified)\nCheck: σ_θ_max < σ_yield/SF (SF ≥ 2) and < σ_endurance/Kt (fatigue)\nIf fail: reduce Ro, increase Ri, change material, or split into stages'],
        ['Step 5 — Shaft design','Torsional shear: τ = T·c/J  where J = πd⁴/32  and  c = d/2\nBending: M = F·L for overhung disc\nCritical speed: ω_c = √(k/m)  (first lateral natural frequency of shaft)\nDesign ω_operating < 0.7 × ω_c  (avoid resonance)'],
        ['Step 6 — Balancing','Static balance: centre of mass on spin axis\nDynamic balance: principal inertia axis aligned with spin axis\nISO 21940: balance grade G2.5 for flywheel on rigid rotors\nResidual unbalance U = m·e  (kg·m)  →  vibration force F = U·ω²'],
        ['Step 7 — Containment','Size containment ring for full rotor kinetic energy at burst speed\nAR500 steel: specific energy absorption ~100–200 J/kg\nContainment mass ≈ 0.5–2 × rotor mass\nStandards: per local regulations for pressure vessels and rotating machinery'],
      ]}/>

      <h2 style={S.h2}>Common Failure Modes &amp; Maintenance</h2>
      <Table2 rows={[
        ['Fatigue cracking','Most common failure in long-life industrial flywheels\nOriginates at stress concentrations: bore, keyway, spoke roots\nDetection: periodic magnetic particle or dye penetrant inspection\nPrevention: generous radii at all stress risers (r ≥ 0.1 × t); shot-peen surfaces'],
        ['Overspeed burst','Catastrophic failure if governor, clutch, or load shedding fails\nPrevention: overspeed trips (≤ 110% rated speed), redundant protection\nCFRP burst: fibre fragmentation — vacuum housing contains\nSteel burst: large fragments — 50mm AR500 containment ring essential'],
        ['Bearing failure','Spalling from fatigue, scoring from contamination, overheating from lack of lubrication\nMonitor: vibration (velocity or acceleration RMS), bearing temperature\nPlan-based maintenance: replace at scheduled interval (e.g. 25,000 hours)\nAMB systems: redundant sensors + catcher bearing as backstop'],
        ['Fretting at interference fit','Micro-slip at hub-shaft interface under cyclic torsion\nResults in fretting corrosion (reddish oxide), stress concentration increase\nPrevention: molybdenum disulphide grease on mating surfaces; optimal interference\nInspection: measure hub run-out; check for reddish oxide at rim of fit'],
        ['Corrosion','Atmospheric corrosion in outdoor or humid environments\nCFRP: galvanic corrosion at Al/steel interfaces; carbon is noble\nProtection: zinc priming + epoxy topcoat; stainless steel fasteners only\nVacuum FESS: internal surfaces cleaned and passivated; getter material inside enclosure'],
        ['Balance deterioration','Blades or spokes cracking, hub loosening, surface deposits\nSymptom: increased vibration (ISO 10816 velocity limits)\nCorrection: field balancing with trial weights; record before/after\nCFRP rotors: delamination changes mass distribution — requires removal and rebalancing'],
      ]}/>

      <InfoBox title="Flywheel Key Equations &amp; Design Values" items={[
        "Kinetic energy:         E = ½·I·ω²    [J]   ·   I = moment of inertia (kg·m²)",
        "Solid cylinder:         I = ½·m·R²",
        "Thin ring:              I = m·R²",
        "Annulus:                I = ½·m·(Ro² + Ri²)",
        "Coefficient of fluctuation: Cs = (ω_max − ω_min) / ω_mean    ·    typical: 0.002 (turbine) to 0.2 (punch press)",
        "Required I:             I = ΔE / (Cs × ω_mean²)",
        "Specific energy (disc): E/m = K·σ_UTS / (2ρ)    K=0.5 disc, K=1.0 ring",
        "Hoop stress (bore):     σ_θ_max ≈ ρ·ω²·(3+ν)/8 · [(Ro²+Ri²) + Ro²Ri²/Ri²]",
        "Tip speed limit:        v_tip = ω·Ro    ·    steel ≤ 300 m/s   ·   CFRP ≤ 700 m/s",
        "Self-discharge:         E(t) = E₀·exp(−t/τ)    τ = I·ω / (2·P_loss)",
        "Balancing grade G2.5:   e = 2.5 / ω  [mm]  (residual eccentricity at operating speed)",
        "Critical shaft speed:   ω_c = √(48·E·I_shaft / (m·L³))   (simply-supported central disc)",
      ]}/>
    </div>
  );
}